import type { UseModalProps } from './use-modal.ts'

import { ModalProvider } from './use-modal.ts'

import { Dialog } from '@headlessui/react'
import { cn } from '@mntn-dev/ui-utilities'
import { AnimatePresence, motion } from 'motion/react'
import type { ReactNode, RefObject } from 'react'
import { useModal } from './use-modal.ts'

export type ModalBaseProps = Readonly<
  UseModalProps & {
    children: ReactNode
    initialFocusRef?: RefObject<HTMLElement | null>
    overlayClassName?: string
    className?: string
    noPositioning?: boolean
  }
>

export const ModalBase = ({
  children,
  initialFocusRef,
  className,
  overlayClassName,
  ...useModalProps
}: ModalBaseProps) => {
  const context = useModal(useModalProps)
  const { getDialogProps, onClose, open } = context

  return (
    <ModalProvider value={context}>
      <AnimatePresence>
        {open && (
          <Dialog
            static
            open={open}
            onClose={onClose}
            initialFocus={initialFocusRef}
            {...getDialogProps()}
          >
            <motion.div
              className={cn(
                'fixed inset-0 z-20 backdrop-blur-lg bg-overlay',
                overlayClassName
              )}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={onClose}
            />
            <div className="fixed inset-0 z-30 w-screen overflow-y-auto">
              {children}
            </div>
          </Dialog>
        )}
      </AnimatePresence>
    </ModalProvider>
  )
}
